import { ChangeDetectionStrategy, Component, input } from "@angular/core";
import { Strategy } from "@front/m19-api-client";
import { StrategyLinkComponent } from "@m19-board/shared/strategy-link/strategy-link.component";

@Component({
  selector: "app-strategy-list-preview",
  imports: [StrategyLinkComponent],
  templateUrl: "./strategy-list-preview.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StrategyListPreviewComponent {
  strategies = input.required<Strategy[]>();
}
